import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Card, CardBody } from 'reactstrap';
import ContactForm from 'components/forms/ContactForm';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import InfoLink from '../../components/InfoLink'

class ContactPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    saveDraft: PropTypes.func.isRequired,
  };

  submitForm = () => this.form.submit();
  formSubmitted = (data) => this.props.submitForm('contact', this.props.history, data);
  saveDraft = () => this.props.saveDraft('contact');
  goToPreviousStep = () => this.props.goToPreviousStep('contact', this.props.history);

  render() {
    return (
      <div>
        <FormButtons onNext={this.submitForm} onPrevious={this.goToPreviousStep} onSaveDraft={this.saveDraft} />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <div className="card-header">
                <h4>Event Contact Details</h4>
              </div>
              <CardBody>
                <p>
                  <b>Public Facing Contact Information</b>
                  <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020924013-Contact-Public-facing-contact-information"/>
                </p>
                <ContactForm
                  ref={(ref) => this.form = ref}
                  onSubmit={this.formSubmitted}
                  formErrors={this.props.formErrors}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formErrors: state.submissionForm.getIn(['steps', 'contact', 'errors']),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/ContactPage.jsx